export default "__VITE_ASSET__DWG2YxfV__"